import React, { Component } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getUser, editUser } from "../../actions/authAction";
import Spinner from "../common/Spinner";
import {
  Table,
  Container,
  FormGroup,
  Card,
  Form,
  CardBody,
  Row,
  Col,
  FormFeedback,
  Label,
  InputGroup,
  InputGroupAddon,
  Input,
  InputGroupText,
  Button
} from "reactstrap";

// import {Form} from "semantic-ui-react";

class EditUser extends Component {

  static defaultProps = {
    locations: ["Chama", "Springer", "Questa", "Lordsburg", "Mora", "Angelfire"]
  }

  constructor(props) {
    super(props);
    this.state = {
      unassignedLocations: this.props.locations,
      search: false,
      searchTerm: "",
      userDetails: {},
      errors: {},
      selectedValue: ""

    };
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.checkbox = this.checkbox.bind(this);
    this.activeToggle = this.activeToggle.bind(this);
  }

  componentDidMount() {
    this.props.getUser(this.props.match.params.id);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (Object.keys(nextProps.auth.userById).length > 0) {
      let selectedValue = "";
      nextProps.auth.userById.roles.map(roles => {
        selectedValue = roles;
      });
      console.log(selectedValue);
      this.setState({
        userDetails: nextProps.auth.userById,
        selectedValue: selectedValue
      });
    }
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }
  }

  select = option => {
    let selection = this.state.userDetails.branches;
    let unassigned = this.state.unassignedLocations;
    selection.unshift(option);
    unassigned.splice(unassigned.indexOf(option), 1);
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        branches: selection
      },
      unassignedLocations: unassigned
    });
  };

  unselect = option => {
    let selection = this.state.userDetails.branches;
    let unassigned = this.state.unassignedLocations;
    selection.splice(selection.indexOf(option), 1);
    unassigned.unshift(option);
    this.setState({
      userDetails: {
        ...this.state.userDetails,
        branches: selection
      },
      unassignedLocations: unassigned
    });
  };

  onChange = e => {
    if (e.target.name === "roles") {
      this.setState({
        userDetails: {
          ...this.state.userDetails,
          [e.target.name]: [e.target.value]
        }
      });
    } else {
      this.setState({
        userDetails: {
          ...this.state.userDetails,
          [e.target.name]: e.target.value
        }
      });
    }
  };

  onSearch = e => {
    e.preventDefault();
    this.setState({ search: true });
    this.setState({ searchTerm: e.target.value.toLowerCase() }, () => {
      let locations;
      locations = _.filter(this.props.locations, location =>
        location.toLowerCase().includes(this.state.searchTerm)
      );
      this.setState({ unassignedLocations: locations });
    });
  };

  checkbox = () => {
    const userDetails = this.state.userDetails;
    userDetails.admin = !userDetails.admin;
    this.setState({
      userDetails: userDetails
    });
  };

  activeToggle = () => {
    const userDetails = this.state.userDetails;
    userDetails.active = !userDetails.active;
    this.setState({
      userDetails: userDetails
    });
  };

  onSubmit = e => {
    e.preventDefault();
    let errors = {};

    this.props.editUser(this.state.userDetails, this.props.history);
  };

  render() {
    const { userDetails, errors, selectedValue } = this.state;
    const { loading } = this.props.auth;
    const invalid = Object.keys(errors).length > 0 && true;
    let selectedOptions;
    const options = this.state.unassignedLocations.map((option, i) => (
      <tr key={option}>
        <td className="cell" onClick={this.select.bind(this, option)}>
          <i className="fas fa-grip-vertical" /> {option}
        </td>
      </tr>
    ));
    if (loading) {
      selectedOptions = <Spinner />;
    } else {
      if (Object.keys(userDetails).length > 0) {
        selectedOptions = userDetails.branches.map(option => (
          <tr key={option}>
            <td className="cell" onClick={this.unselect.bind(this, option)}>
              <i className="fas fa-grip-vertical" />
              {option}
            </td>
          </tr>
        ));
      } else
        selectedOptions = (
          <tr>
            <td>No branches to display</td>
          </tr>
        );
    }

    return (
      <Container>
        <Card className="card-top mx-auto">
          <CardBody>
            <Form onSubmit={this.onSubmit}>
              <Row>
                <Col md="8" className="text-right">
                  <h1 className="mb-4 h1-font">Edit User Info</h1>
                </Col>
                <Col md="4" className="text-right">
                  <FormGroup className="form-group-position">
                    <span className=" switch switch-sm">
                      <Input
                        type="checkbox"
                        checked={userDetails.active}
                        onChange={this.activeToggle}
                        className="switch"
                        id="switch-id"
                      />
                      <Label htmlFor="switch-id">Active</Label>
                    </span>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md="6">
                  <FormGroup className="form-group-position">
                    <Input
                      type="text"
                      name="firstName"
                      className="form-control form-border text-capitalize"
                      defaultValue={userDetails.firstName}
                      onChange={this.onChange}
                      required
                    />
                    <Label
                      className="form-control-placeholder"
                      htmlFor="First Name"
                    >
                      First Name
                    </Label>
                  </FormGroup>
                </Col>
                <Col md="6">
                  <FormGroup className="form-group-position">
                    <Input
                      type="text"
                      name="lastName"
                      className="form-control form-border text-capitalize"
                      defaultValue={userDetails.lastName}
                      onChange={this.onChange}
                      required
                    />
                    <Label
                      className="form-control-placeholder"
                      htmlFor="Last Name"
                    >
                      Last Name
                    </Label>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md="4">
                  <FormGroup className="form-group-position">
                    <Input
                      type="email"
                      name="emailAddress"
                      className="form-control form-border"
                      defaultValue={userDetails.emailAddress}
                      onChange={this.onChange}
                      required
                    />
                    <Label
                      className="form-control-placeholder"
                      htmlFor="Email Address"
                    >
                      Email Address
                    </Label>
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup className="form-group-position">
                    <Input
                      invalid={invalid}
                      type="number"
                      name="phoneNumber"
                      className="form-control form-border"
                      defaultValue={userDetails.phoneNumber}
                      onChange={this.onChange}
                    />
                    <Label
                      className="form-control-placeholder"
                      htmlFor="Email Address"
                    >
                      Phone #
                    </Label>
                    <FormFeedback>{errors.message}</FormFeedback>
                  </FormGroup>
                </Col>
                <Col md="4">
                  <FormGroup className="form-group-position">
                    <select
                      name="roles"
                      value={selectedValue}
                      onChange={this.onChange}
                      className="form-control form-border"
                    >
                      <option value="PHARMACIST">Pharmacist</option>
                      <option value="TECHNICIAN">Technician</option>
                    </select>
                    <Label className="form-control-placeholder" htmlFor="roles">
                      Role
                    </Label>
                  </FormGroup>
                </Col>
                <Col md="2">
                  <FormGroup className="float-right d-inline form-group-position">
                    <div className="form-check">
                      <Label
                        className="form-check-label"
                        htmlFor="defaultCheck1"
                      >
                        <Input
                          invalid={invalid}
                          className="form-check-input"
                          name="admin"
                          type="checkbox"
                          checked={userDetails.admin}
                          onChange={this.checkbox}
                        />
                        Admin
                      </Label>
                    </div>
                  </FormGroup>
                </Col>
              </Row>
              <div className="text-intro">
                <h4>Assign to branches</h4>
                <h5 className="text-muted">
                  Locations available to this user for filling prescriptions
                </h5>
              </div>
              <Row>
                <Col md="6">
                  <h5 className="text-muted">AVAILABLE LOCATIONS:</h5>
                  <Card className="card card-scroll">
                    <Table hover>
                      <thead>
                        <tr>
                          <td>
                            <InputGroup>
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText className="input">
                                  <i className="fas fa-search" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                type="text"
                                className="search-icon"
                                placeholder="Search..."
                                onChange={this.onSearch.bind(this)}
                              />
                            </InputGroup>
                          </td>
                        </tr>
                        {options}
                      </thead>
                    </Table>
                  </Card>
                  <h5 className="text-muted">Click to assign a location</h5>
                </Col>
                <Col md="6">
                  <h5 className="text-muted">ASSIGNED LOCATIONS:</h5>
                  <Card className="card card-scroll">
                    <Table hover>
                      <tbody>{selectedOptions}</tbody>
                    </Table>
                  </Card>
                  <h5 className="text-muted">Click to remove a location</h5>
                </Col>
              </Row>
              <div className="clearfix wrapper">
                <FormGroup>
                  <Button color="primary" size="md" className="float-right">
                    Save
                  </Button>
                </FormGroup>
              </div>
            </Form>
          </CardBody>
        </Card>
      </Container>
    );
  }
}

EditUser.propTypes = {
  getUser: PropTypes.func.isRequired,
  editUser: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, { getUser, editUser })(
  withRouter(EditUser)
);
